import React, { useEffect, useState } from 'react'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/material_blue.css'
import { useTranslation } from 'react-i18next'
function ODatePicker ({
  handleDateChange,
  value,
  placeholder,
  startDate,
  handleAuctionStartDate,
  handleAuctionEndDate,
  name,
  inputLabel
}) {
  const [selectedDate, setSelectedDate] = useState('')
  const { t } = useTranslation()
  const onChange = ([date]) => {
    setSelectedDate(date)
    if (placeholder === t('O_AUCTION_START_DATE')) {
      handleAuctionStartDate(date)
    } else if (placeholder === t('O_AUCTION_END_DATE')) {
      handleAuctionEndDate(date)
    } else {
      handleDateChange(date)
    }
  }
  useEffect(() => {
    if (value) {
      setSelectedDate(value)
    }
  }, [value])
  return (
    <div className={'relative z-0 mb-6 w-full group'}>
      <label
        htmlFor={name}
        className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
      >
        {inputLabel}
      </label>
      <Flatpickr
        //   className="flex flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
        name='date'
        placeholder={placeholder ?? t('OFFERS_VALIDITY')}
        value={new Date(value)}
        options={{
          // minDate: startDate ? new Date(new Date(startDate).getTime() + 24 * 60 * 60 * 1000) : '',
          // minDate: dayjs().add(1, 'day') ,
          // minDate:  tomorrow.setSelectedDate(tomorrow.getDate() + 1) ,
          // minDate:  'tomorrow' ,
          // minDate:  'today + 1' ,
          minDate: new Date().fp_incr(1),
          dateFormat: 'd-m-y',
          defaultDate: selectedDate
        }}
        onChange={onChange}
      />
    </div>
  )
}

export default ODatePicker
